
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63.733 12.436c-.266-.265-.533-.53-1.066-.53H12l-1.333-6.879c0-.53-.8-1.058-1.334-1.058h-8C.533 3.969 0 4.498 0 5.292c0 .793.533 1.323 1.333 1.323h6.934l6.4 32.28c.8 4.234 4.8 7.41 9.066 7.41H54.4c.8 0 1.333-.53 1.333-1.323 0-.794-.533-1.323-1.333-1.323H24c-2.133 0-4.267-1.059-5.333-2.911L57.6 35.456c.533 0 1.067-.53 1.067-1.058L64 13.23s0-.53-.267-.794zm-7.466 20.639l-38.934 5.027-4.8-23.814H60.8l-4.533 18.787zM22.667 48.951c-3.734 0-6.667 2.91-6.667 6.615 0 3.704 2.933 6.615 6.667 6.615 3.733 0 6.666-2.91 6.666-6.615 0-3.704-2.933-6.615-6.666-6.615zm0 10.584c-2.134 0-4-1.852-4-3.969s1.866-3.969 4-3.969c2.133 0 4 1.852 4 3.97 0 2.116-1.867 3.968-4 3.968zM49.332 48.951c-3.734 0-6.667 2.91-6.667 6.615 0 3.704 2.933 6.615 6.667 6.615 3.733 0 6.666-2.91 6.666-6.615 0-3.704-2.933-6.615-6.666-6.615zm0 10.584c-2.134 0-4-1.852-4-3.969s1.866-3.969 4-3.969c2.133 0 4 1.852 4 3.97 0 2.116-1.867 3.968-4 3.968z","fill":"#1BA7E1"}})])
          )
        }
      }
    